module.exports = "0.38.0";



//////////////////
// WEBPACK FOOTER
// ./~/autocomplete.js/version.js
// module id = 850
// module chunks = 0